Ext.define('SA.model.ConditionFactory', {
    createBetweenCondition(params) {
        return new SA.model.BetweenCondition(params);
    },

    createList({operator, conditions}) {
        return new SA.model.ConditionList({operator, conditions});
    },

    createUnaryCondition(params) {
        return new SA.model.UnaryCondition(params);
    }
});